import { Controller } from "@hotwired/stimulus"

// Greys out the submit button the instant its form is submitted, so a slow
// video upload (native browser submission, not Turbo — see the recording
// forms' `data: { turbo: false }`) can't be double-submitted by an impatient
// tap. The page navigates away on success/failure, so there's no matching
// re-enable.
export default class extends Controller {
  static targets = ["submit"]

  disable() {
    this.submitTargets.forEach((btn) => {
      btn.disabled = true
      btn.dataset.originalText ||= btn.value || btn.textContent
      if ("value" in btn) {
        btn.value = "Uploading…"
      } else {
        btn.textContent = "Uploading…"
      }
    })
  }
}
